import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/modules/material/material-module.module';
import { CardNewsComponent } from './card-news.component';

@NgModule({
  declarations: [CardNewsComponent],
  imports: [CommonModule, MaterialModule, TranslateModule],
  exports: [CardNewsComponent],
})
export class CardNewsModule {}
